<template>
    <ListingModel />
</template>


<script>
import ListingModel from "@/views/Edms/Document/Components/ListingModel.vue";

export default {
    name: "Documents",
    components: {ListingModel},
}
</script>

<style scoped>

</style>